module.exports = __webpack_public_path__ + "assets/long-click-save.png";